module.exports = __webpack_public_path__ + "static/img/1.eaa20544.png";